import { Alert, Grid, Tab, Tabs } from "@mui/material";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { useEffect, useState } from "react";
import CompletionForm from "./CompletionForm";
import CustomButton from "../../../../components/common/button/CustomButton";
import ManageFeedback from "./ManageFeedback";
import ManageViewFeedback from "./ManageViewFeedback";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getAllFeedbackListAction,
  getAskFeedbackAction,
  getSingleLeadCompletionNotesAction,
  setAskFeedbackResponse,
} from "../../../../store/reducers/feedbackSlice";
import ManageCompletion from "./ManageCompletion";
import ManageInvoice from "../../invoice/ManageInvoice";
import { setDeletedInvoiceResponse } from "../../../../store/reducers/invoiceSlice";
import QuoteList from "./QuoteList";
import ComplaintList from "../ComplaintList";
import LeadTask from "../jobCompletion/LeadTask";
import ReviewList from "../jobCompletion/ReviewList";
import { getLeadEstimateAction } from "../../../../store/reducers/leadSlice";

const LeadCompletion = () => {
  const [show, setShow] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [openFeedbackView, setOpenFeedbackView] = useState(false);
  const [invoiceModel, setInvoiceModel] = useState(false);
  const [selectedQuote, setSelectedQuote] = useState<any>(null);
  const [showQuoteList, setShowQuoteList] = useState(false);
  const [showCompleteAlert, setShowCompleteAlert] = useState(false);
  // tab
  const [tabValue, setTabValue] = useState(0);
  const [activeQuoteId, setActiveQuoteId] = useState<string | null>(null);
    const dispatch = useDispatch();
  const { leadDetails, selectedLeadQuote } = useSelector(
    (state: any) => state.lead,
  );
  const {
    singleLeadFeedback,
    singleLeadCompletionNotes,
    feedbacks,
    askFeedbackResponse,
  } = useSelector((state: any) => state.feedback);
  const { isAddInvoiceResponse, isDeletedInvoiceResponse } = useSelector(
    (state: any) => state.invoice,
  );

  const acceptedQuotes = (selectedLeadQuote?.quotes || []).filter(
    (quote: any) =>
      String(quote?.accepted_status || "").toLowerCase() === "accepted",
  );

  const handleChange = (event: any, newValue: number) => {
    setTabValue(newValue);
    const selectedQuote = acceptedQuotes?.[newValue];

    if (selectedQuote) {
      setActiveQuoteId(selectedQuote.quoteId);
    }
  };


  const { userProfile } = useSelector((state: any) => state?.user);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false, // Safe fallback
  );
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false, // Safe fallback
  );

  const [isNewInvoice, setIsNewInvoice] = useState(false);
  console.log("selectedLeadQuote", selectedLeadQuote);
  useEffect(() => {
    if (
      leadDetails?.lead?.generated_id &&
      leadDetails?.lead?.status !== "ESTIMATES"
    ) {
      dispatch(
        getLeadEstimateAction({
          generatedId: leadDetails?.lead?.generated_id,
          screenType: "quotation",
        }),
      );
      dispatch(getAllFeedbackListAction());
      dispatch(
        getSingleLeadCompletionNotesAction(leadDetails?.lead?.generated_id),
      );
      setShow(false);
    }
  }, [leadDetails]);

  const handlAskFeedback = () => {
    dispatch(getAskFeedbackAction(leadDetails?.lead?.generated_id));
  };

  useEffect(() => {
    if (askFeedbackResponse) {
      dispatch(setAskFeedbackResponse(false));
    }
  }, [askFeedbackResponse]);

  const handleClose = () => {
    setInvoiceModel(false);
    setIsNewInvoice(false);
    if (leadDetails) {
      dispatch(
        getSingleLeadCompletionNotesAction(leadDetails?.lead?.generated_id),
      );
    }
  };

  const handleInvoice = () => {
    setInvoiceModel(true);
    setIsNewInvoice(false);
  };

  useEffect(() => {
    if (isAddInvoiceResponse || isDeletedInvoiceResponse) {
      setInvoiceModel(false);
      setIsNewInvoice(false);
      dispatch(setDeletedInvoiceResponse(false));
    }
  }, [isAddInvoiceResponse, isDeletedInvoiceResponse]);

  const handleNewInvoice = () => {
    setInvoiceModel(true);
    setIsNewInvoice(true);
  };

  const handleShowActiveInvoice = () => {
    setShowQuoteList(true);
  };

  const formatDate = (date: string) => {
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const year = String(d.getFullYear()).slice(-2);

    return `${day}${month}${year}`;
  };

  useEffect(() => {
    if (acceptedQuotes.length === 0) {
      setTabValue(0);
      setActiveQuoteId(null);
      return;
    }

    if (tabValue >= acceptedQuotes.length) {
      setTabValue(0);
    }

    if (acceptedQuotes?.[0]?.quoteId) {
      setActiveQuoteId(acceptedQuotes[0].quoteId);
    }
  }, [acceptedQuotes, tabValue]);

  const currentQuote = acceptedQuotes?.[tabValue];
  const currentQuoteId =
    currentQuote?.quoteId || currentQuote?.quote_id || activeQuoteId;
  const completionNotesList = Array.isArray(singleLeadCompletionNotes)
    ? singleLeadCompletionNotes
    : singleLeadCompletionNotes
      ? [singleLeadCompletionNotes]
      : [];
  const selectedCompletionNotes = completionNotesList.find(
    (note: any) => (note?.quote_id || note?.quoteId) === currentQuoteId,
  );

  const fallbackFromQuote = {
    quote_id: currentQuoteId,
    quote_note: currentQuote?.quotenote ?? currentQuote?.notes ?? null,
    transport_note: currentQuote?.transportnote ?? "",
    confirmation_note: null,
    job_note: null,
    survey_note: null,
  };

  const effectiveCompletionNotes = selectedCompletionNotes || fallbackFromQuote;

  const normalizedCompletionNotes = {
    ...effectiveCompletionNotes,
    notes: {
      ...(effectiveCompletionNotes?.notes || {}),
      quote_note: effectiveCompletionNotes?.quote_note ?? null,
      customer_note: effectiveCompletionNotes?.customer_note ?? null,
      confirmation_note: effectiveCompletionNotes?.confirmation_note ?? null,
      job_note: effectiveCompletionNotes?.job_note ?? null,
      survey_note: effectiveCompletionNotes?.survey_note ?? null,
      transport_note: effectiveCompletionNotes?.transport_note ?? "",
      crew_id: effectiveCompletionNotes?.notes?.crew_id ?? null,
      crew_notes: effectiveCompletionNotes?.notes?.crew_notes ?? "",
    },
  };

  return (
    <>
      <ManageCompletion
        open={showCompleteAlert}
        leadDetails={leadDetails}
        onHide={() => setShowCompleteAlert(false)}
        title="Alert"
      />
      {showQuoteList && (
        <QuoteList
          open={showQuoteList}
          onHide={() => setShowQuoteList(false)}
          title="Quotes List"
          onSelect={() => handleInvoice()}
          setSelectedQuote={setSelectedQuote}
        />
      )}
      {openFeedback && (
        <ManageFeedback
          open={openFeedback}
          onHide={() => setOpenFeedback(false)}
          title="Customer Feeback"
        />
      )}
      {openFeedbackView && (
        <ManageViewFeedback
          open={openFeedbackView}
          onHide={() => setOpenFeedbackView(false)}
          title="Customer Feeback View"
        />
      )}
      <Grid item xs={12} md={2.4}>
        <CustomButton
          style={{ padding: "10px 30px", height: "36px", width: "100%" }}
          title="Completion"
          onClick={() => {
            setShow(!show);
          }}
          disabled={
            leadDetails?.lead?.status === "JOB" ||
            leadDetails?.lead?.status === "COMPLETED" ||
            leadDetails?.lead?.status === "DISPUTE"
              ? false
              : true
          }
        />
        {/* <PageTitle
          title={""}
          button="Completion"
          onClick={() => {
            setShow(!show);
          }}
          btnDisabled={
            leadDetails?.lead?.status === "JOB" ||
            leadDetails?.lead?.status === "COMPLETED"
              ? false
              : true
          }
        /> */}
      </Grid>
      {show && (
        <>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "0px !important",
              marginTop: "10px",
            }}
          >
            <CustomButton
              onClick={() => handlAskFeedback()}
              title="Ask for feedback"
            />
            <CustomButton
              disabled={!singleLeadFeedback}
              style={{ marginRight: "6px" }}
              onClick={() => setOpenFeedbackView(true)}
              title="View feedback"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            {(!feedbacks || feedbacks.length === 0 || !singleLeadFeedback) && (
              <Alert severity="info">
                Add feedback questionnaire in settings to activate the customer
                feedback system
              </Alert>
            )}
          </Grid>
        </>
      )}
      <>
        {show && (
          <>
            {/* tab wise */}
            <Tabs
              value={tabValue}
              onChange={handleChange}
              sx={{ minHeight: 30, marginLeft: "16px" }}
            >
              {acceptedQuotes.map((quote: any, index: number) => {
                const dateLabel = formatDate(
                  quote?.updated_at || quote?.created_at,
                );

                return (
                  <Tab
                    key={quote.quoteId}
                    label={`${index + 1} - ${dateLabel}`}
                    sx={{
                      minHeight: 30,
                      fontWeight: 600,
                      textTransform: "none",
                      marginRight: "6px",
                      borderRadius: "6px",
                      backgroundColor: "#f5f5f5",

                      "&.Mui-selected": {
                        backgroundColor: "#e5f4f1",
                        // color: "#fff",
                      },
                    }}
                  />
                );
              })}
            </Tabs>
            {/* Active Quote */}
            {acceptedQuotes?.[tabValue] && (
              <>
                <Grid item xs={12} md={12}>
                  <CompletionForm
                    singleLeadCompletionNotes={normalizedCompletionNotes}
                  />
                </Grid>
                {/*  */}
                <Grid item xs={12} md={12} sx={{ paddingBottom: "10px" }}>
                  <>
                    {leadDetails?.lead?.status !== "COMPLETED" && (
                      <>
                        {invoiceModel && (
                          <ManageInvoice
                            title={
                              isNewInvoice ? "Create New Invoice" : "Invoice"
                            }
                            open={invoiceModel}
                            onHide={handleClose}
                            invoiceType={isNewInvoice ? "" : "final"}
                            isNewInvoice={isNewInvoice ?? false}
                            isSetLeadDetails={isNewInvoice ? true : false}
                            isCompletionInvoice={true}
                            selectedQuote={selectedQuote}
                          />
                        )}

                        <CustomButton
                          style={{ marginRight: "6px" }}
                          title="Invoice"
                          onClick={() =>
                            isProfessionalSection
                              ? handleShowActiveInvoice()
                              : handleInvoice()
                          }
                        />
                        {!isBasicDiarySection && (
                          <CustomButton
                            style={{ marginRight: "6px" }}
                            title="Create New Invoice"
                            onClick={() => handleNewInvoice()}
                          />
                        )}
                        {/* Todo */}
                        {/* <CustomButton
            disabled
            style={{ marginRight: "6px" }}
            title="Previous Invoice"
            // onClick={() => setShow(false)}
          /> */}
                        <CustomButton
                          // disabled={
                          //   !normalizedCompletionNotes?.invoice_number
                          //     ? true
                          //     : false
                          // }
                          disabled={leadDetails?.lead?.status === "COMPLETED" ? true : false}
                          style={{ marginRight: "6px" }}
                          title="Complete"
                          onClick={() => setShowCompleteAlert(true)}
                        />
                      </>
                    )}
                    <section style={{ width: "100%", marginTop: "10px" }}>
                      <ComplaintList
                        show={show}
                        activeQuoteId={acceptedQuotes?.[tabValue]}
                      />
                    </section>
                    <section style={{ width: "100%", marginTop: "10px" }}>
                      <LeadTask activeQuoteId={acceptedQuotes?.[tabValue]} />
                    </section>
                    <section style={{ width: "100%", marginTop: "10px" }}>
                      <ReviewList activeQuoteId={acceptedQuotes?.[tabValue]} />
                    </section>
                  </>
                </Grid>
              </>
            )}
          </>
        )}
      </>
    </>
  );
};

export default LeadCompletion;
